import React, { useEffect, useState } from 'react';
import { Button, Col, Form, InputGroup, Modal, Row } from 'react-bootstrap';
import { Formik, Form as FormikForm } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import CandidateTag from '../../../models/candidate-tag.interface';
import RegistrationTag from '../registration-tag/RegistrationTag';
import {
  addSkills,
  updateCandidate,
} from '../../../store/slices/candidateSlice';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Option } from 'react-bootstrap-typeahead/types/types';
import { useTranslation } from 'react-i18next';
import { ListItem } from '../../../models/list-item';
import { getItemById } from '../../../utils/get-item-by-id';

interface Props {
  show: boolean;
  handleClose: () => void;
}

const CandidateSkillModal = ({ show, handleClose }: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const [selectedTags, setSelectedTags] = useState<CandidateTag[]>([]);
  const [skillList, setSkillList] = useState<Option[]>(
    t('aptitudeList', { returnObjects: true })
  );
  const currentSkills = useSelector(
    (state: RootState) => state.candidateReducer.skills
  );
  const suggestions: ListItem[] = t('aptitudeSuggestions', {
    returnObjects: true,
  });

  const englishAptitudeList: ListItem[] = t('aptitudeList', {
    lng: 'en',
    returnObjects: true,
  });

  function deleteSelectedTag(tag: ListItem): void {
    setSelectedTags((prevValue) => {
      return prevValue.filter((item) => item.id !== tag.id);
    });

    setSkillList((prev) => {
      const skills = [...prev];
      skills.push(tag);
      (skills as ListItem[]).sort((a, b) => a.name.localeCompare(b.name));
      return skills;
    });
  }

  function addSelectedTag(tag: CandidateTag): void {
    setSelectedTags((prevValue) => {
      const copy = [...prevValue];
      if (copy.some((item) => item.name === tag.name)) return prevValue;
      tag.description = getItemById(englishAptitudeList, tag.id);
      copy.push(tag);
      return copy;
    });
  }

  function removeSkillFromList(skillIndex: number): void {
    setSkillList((prev) => {
      const skills = [...prev];
      skills.splice(skillIndex, 1);
      return skills;
    });
  }

  useEffect(() => {
    if (show === true) {
      let result: ListItem[] = t('aptitudeList', { returnObjects: true });
      currentSkills.forEach((skill) => {
        result = result.filter((aptitude) => skill.id !== aptitude.id);
      });
      setSkillList(result);
    }
  }, [show]);

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('softSkillLabel')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{}}
          onSubmit={(_) => {
            const skillNames = Array.from(
              new Set(currentSkills.map((item) => item.name))
            );

            const uniqueTags = selectedTags.filter(
              (item) => !skillNames.some((skill) => skill === item.name)
            );

            if (uniqueTags.length) {
              dispatch(addSkills(uniqueTags));
              dispatch(updateCandidate());
            }

            setSelectedTags([]);
            handleClose();
          }}
        >
          {({}) => (
            <FormikForm className='form w-100 d-flex justify-content-evenly flex-column'>
              <Row>
                <div>
                  <Row>
                    <Form.Group as={Col} controlId='validationCustom01'>
                      <InputGroup hasValidation>
                        <Typeahead
                          id='basic-typeahead-single'
                          className='mt-2 w-100'
                          labelKey='name'
                          onChange={(element) => {
                            const selected: ListItem = element[0] as ListItem;
                            const selectedIndex = (
                              skillList as ListItem[]
                            ).findIndex((item) => item.id === selected.id);

                            addSelectedTag(selected);
                            removeSkillFromList(selectedIndex);
                          }}
                          options={skillList}
                          placeholder=''
                          selected={[]}
                        />
                      </InputGroup>
                    </Form.Group>
                  </Row>

                  {selectedTags.length > 0 && (
                    <div className='selected-tags'>
                      {selectedTags.map((tag: CandidateTag, index: number) => {
                        return (
                          <RegistrationTag
                            key={index}
                            tag={tag as ListItem}
                            deleteTag={deleteSelectedTag}
                          />
                        );
                      })}
                    </div>
                  )}

                  {/*
                  <div className='suggestion-section'>
                    <h5>{t('candidateSkillModal.suggestions')}</h5>
                    <div className='suggestion-section__tag-container'>
                      {suggestions.map((item: ListItem, index: number) => {
                        return (
                          <button
                            type='button'
                            className='suggestion-section__tag'
                            key={index}
                            onClick={() => addSelectedTag(item)}
                          >
                            {item.name}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                  */}
                </div>
              </Row>
              <Button className='submitbtn sans p-3' type='submit'>
                {t('submitButton')}
              </Button>
            </FormikForm>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default CandidateSkillModal;
